<!-- 广告内容管理 -->
<template>
  <div class="classification2" :style="contentHeight ? `height:${contentHeight}px!important` : ''">
    <div class="header">
      <el-form ref="formTool" :inline="true" style="text-align: left">
        <div>
          <el-form-item prop="nameLike" label="">
            <el-tabs v-model="activeName">
              <el-tab-pane label="广告内容管理" name="first">
              </el-tab-pane>
              <el-tab-pane label="广告位设置" name="second">
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <contentList ref="content-list" v-if="activeName == 'first'" />
    <positionList ref="position-list" v-if="activeName == 'second'" />
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import contentList from "./contentList.vue";
import positionList from "./positionList.vue";

export default {
  components: { MyTable, contentList, positionList },
  data() {
    return {
      headHeight: 60,
      contentHeight: 1100,
      activeName: 'first',
      classificationStyle: 2
    };
  },
  computed: {},
  watch: {
    headHeight: function (newVal, oldVal) {
     
    },
  },
  created() {

  },
  mounted() {
    this.getWindowView();
    window.addEventListener('resize', this.getWindowView);
  },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() {
    // 在组件销毁前移除窗口尺寸变化事件的监听器
    window.removeEventListener('resize', this.getWindowView);
  },
  destroyed() { },
  activated() { },
  computed: {

  },
  methods: {
    getWindowView() {
      let pageWidth = window.innerWidth; //获取页面宽度
      let innerHeight = window.innerHeight; //获取页面高度 
      let headHeight = 60;
      if (this.activeName == 'first') {
        headHeight = this.$refs['content-list'].$refs.formTool.$el.clientHeight; //获取子页面head 高度 
      }

      if (this.activeName == 'second') {
        headHeight = this.$refs['position-list'].$refs.formTool.$el.clientHeight; //获取子页面head 高度 
      }

      let contentHeight = innerHeight - 40 - headHeight;
      this.headHeight = headHeight;
      this.contentHeight = contentHeight;
    }

  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/variables.scss";

.classification {
  background: white;
  overflow: inherit;

  .header {
    width: 100%;
    margin: 0 10px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  .top {
    display: flex;
    padding: 10px 0 10px 0;

    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        width: 120px;
      }

      .button {
        margin-right: 20px;

        ::v-deep .el-button {
          color: $subMenuActiveText;
          background-color: $butColor;
          border-color: $butColor;

          &:hover {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:active {
            color: $subMenuActiveText;
            background: $butColor;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:focus {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
        }
      }
    }
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    justify-content: space-around;

  }
}

.classification {
  border-radius: 4px !important;
  background: white;
  //height: calc(100vh - 118px);
  padding: 0px 24px 24px 24px;

  .main {
    height: 100%;
  }
}

.classification2 {
  border-radius: 4px !important;
  background: white;
  // height: calc(100vh - 108px);
  padding: 0px 24px 24px 24px;

  .main {
    height: 100%;
  }
}
</style>
